import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import EnvironmentVariables from '../utils/EnvironmentVariables';

export default function AuthError() {
  const { error, clearError } = useAuth();
  const idToken = localStorage.getItem('idToken');

  useEffect(() => {
    if (error) {
      const timer = setTimeout(clearError, 5000); // Clear error after 5 seconds
      return () => clearTimeout(timer);
    }
  }, [error, clearError]);

  if (!error && idToken) return null;

  return (
    <div
      onClick={() => !idToken && (window.location.href = EnvironmentVariables.AuthURL)}
      style={{
        position: 'fixed',
        top: '1rem',
        right: '1rem',
        backgroundColor: !idToken ? '#007bff' : '#ff4444',
        color: 'white',
        padding: '1rem',
        borderRadius: '0.5rem',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
        zIndex: 1000,
        maxWidth: '300px',
        cursor: !idToken ? 'pointer' : 'default',
        transition: 'background-color 0.3s, transform 0.3s',
        ':hover': !idToken && {
          backgroundColor: '#0056b3',
          transform: 'scale(1.02)'
        }
      }}
    >
      {error || 'Login'}
    </div>
  );
} 